import type { SVGProps } from 'react'
const SvgExpandCCP = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2 16C1.45 16 0.979167 15.8042 0.5875 15.4125C0.195833 15.0208 0 14.55 0 14V7H2V14H18V2H9V0H18C18.55 0 19.0208 0.195833 19.4125 0.5875C19.8042 0.979167 20 1.45 20 2V14C20 14.55 19.8042 15.0208 19.4125 15.4125C19.0208 15.8042 18.55 16 18 16H2ZM15.075 12.5L16.5 11.075L13.4 8H16V6H10V12H12V9.425L15.075 12.5ZM0 5V0H7V5H0Z"
      fill="#1F1F1F"
    />
  </svg>
)
export default SvgExpandCCP
